import React, { useEffect } from "react";
import { connect } from "react-redux";

import TopFarmersList from "views/console/default/components/TopFarmersList";
import TopFarmersByAnimalType from "views/console/default/components/TopFarmersByAnimalType";
import { 
	getTopCarabaoFarmers,
  getTopCattleFarmers,
  getTopGoatFarmers,
  getTopSheepFarmers,
  getTopSwineFarmers,
  getTopChickenFarmers,
  getTopDuckFarmers,
  getTopFarmers,
} from "../../../redux/dashboard/dashboardState";
import { Collapse } from 'antd';
import TopFarmersSearchFilter from "components/search/TopFarmersSearchFilter";

const TopFarmersView = ({filters, 
  searchTopCarabaoFarmers,
  searchTopCattleFarmers,
  searchTopGoatFarmers,
  searchTopSheepFarmers,
  searchTopSwineFarmers,
  searchTopChickenFarmers,
  searchTopDuckFarmers,
  topCarabaoFarmers,
  topCattleFarmers,
  topGoatFarmers,
  topSheepFarmers,
  topSwineFarmers,
  topChickenFarmers,
  topDuckFarmers,
  getTableData,
  ...props}) => {

  useEffect(() => {
    searchTopCarabaoFarmers(filters);
  }, [searchTopCarabaoFarmers, filters]);

  useEffect(() => {
    searchTopCattleFarmers(filters);
  }, [searchTopCattleFarmers, filters]);

  useEffect(() => {
    searchTopGoatFarmers(filters);
  }, [searchTopGoatFarmers, filters]);

  useEffect(() => {
    searchTopSheepFarmers(filters);
  }, [searchTopSheepFarmers, filters]);

  useEffect(() => {
    searchTopSwineFarmers(filters);
  }, [searchTopSwineFarmers, filters]);

  useEffect(() => {
    searchTopChickenFarmers(filters);
  }, [searchTopChickenFarmers, filters]);

  useEffect(() => {
    searchTopDuckFarmers(filters);
  }, [searchTopDuckFarmers, filters]);

  useEffect(() => {
    getTableData(filters);
    }, [getTableData, filters]);

  const searchFilterHandler = (filterData) => {
    getTableData(filterData);
    searchTopCarabaoFarmers(filterData);
    searchTopCattleFarmers(filterData);
    searchTopGoatFarmers(filterData);
    searchTopSheepFarmers(filterData);
    searchTopSwineFarmers(filterData);
    searchTopChickenFarmers(filterData);
    searchTopDuckFarmers(filterData);
  }

  return (
    <div className="pt-4">

        <div className="mt-3">
          <Collapse
            size="large"
            items={
              [{ key: '1', 
                label: <h4 className="font-bold">Apply Filters</h4>, 
                children: <TopFarmersSearchFilter searchFilterHandler={searchFilterHandler} /> }
              ]
            }
          />
        </div>
        
        <TopFarmersList/> 

        <div className="grid grid-cols-1 md: grid-cols-2 gap-2 mt-8">
          <div>
            <h2 className="font-medium text-xl px-4">Top Carabao Farmers</h2>
            <TopFarmersByAnimalType recordList={topCarabaoFarmers} animalType="carabao"/>
          </div>

          <div>
            <h2 className="font-medium text-xl px-4">Top Cattle Farmers</h2>
            <TopFarmersByAnimalType recordList={topCattleFarmers} animalType="cattle"/>
          </div>

          <div>
            <h2 className="font-medium text-xl px-4">Top Goat Farmers</h2>
            <TopFarmersByAnimalType recordList={topGoatFarmers} animalType="goat"/>
          </div>

          <div>
            <h2 className="font-medium text-xl px-4">Top Sheep Farmers</h2>
            <TopFarmersByAnimalType recordList={topSheepFarmers} animalType="sheep"/>
          </div>

          <div>
            <h2 className="font-medium text-xl px-4">Top Swine Farmers</h2>
            <TopFarmersByAnimalType recordList={topSwineFarmers} animalType="swine"/>
          </div>

          <div>
            <h2 className="font-medium text-xl px-4">Top Chicken Farmers</h2>
            <TopFarmersByAnimalType recordList={topChickenFarmers} animalType="chicken"/>
          </div>

          <div>
            <h2 className="font-medium text-xl px-4">Top Duck Farmers</h2>
            <TopFarmersByAnimalType recordList={topDuckFarmers} animalType="duck"/>
          </div>
          
        </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
    filters: state.dashboard.topFarmersFiters,
    requesting: state.dashboard.widgetsData?.requesting,
    topCarabaoFarmers: state.dashboard.topCarabaoFarmers?.items,
    topCattleFarmers: state.dashboard.topCattleFarmers?.items,
    topGoatFarmers: state.dashboard.topGoatFarmers?.items,
    topSheepFarmers: state.dashboard.topSheepFarmers?.items,
    topSwineFarmers: state.dashboard.topSwineFarmers?.items,
    topChickenFarmers: state.dashboard.topChickenFarmers?.items,
    topDuckFarmers: state.dashboard.topDuckFarmers?.items});

const mapDispatchToProps = (dispatch) => ({
  searchTopCarabaoFarmers: (data) => dispatch(getTopCarabaoFarmers(data)),
  searchTopCattleFarmers: (data) => dispatch(getTopCattleFarmers(data)),
  searchTopGoatFarmers: (data) => dispatch(getTopGoatFarmers(data)),
  searchTopSheepFarmers: (data) => dispatch(getTopSheepFarmers(data)),
  searchTopSwineFarmers: (data) => dispatch(getTopSwineFarmers(data)),
  searchTopChickenFarmers: (data) => dispatch(getTopChickenFarmers(data)),
  searchTopDuckFarmers: (data) => dispatch(getTopDuckFarmers(data)),
  getTableData: (filters) => dispatch(getTopFarmers(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopFarmersView);
